import { OrderLineItemDto, OrderReviewLineItemDto } from "../dtos";

export function isOrderReviewLineItemDto(record: any): record is OrderReviewLineItemDto {
    return 'orderReviewId' in record;
}

export function isOrderLineItemDto(record: any): record is OrderLineItemDto {
    return !('orderReviewId' in record);
}